module.exports = __webpack_public_path__ + "static/media/crossover.6b6d70ce.png";